import { render, staticRenderFns } from "./Faltan.vue?vue&type=template&id=2310d35a"
import script from "./Faltan.vue?vue&type=script&lang=js"
export * from "./Faltan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports